module.exports = "/_next/static/images/Ruxandra_Creizan-36d00124061a7403868c0bf9f27982b0.webp";